import { Checkbox, CheckboxProps } from '@mui/material';

const UbiCheckbox = ({ ...props }: CheckboxProps) => {
    return <Checkbox {...props} sx={{ '& .MuiSvgIcon-root': { fontSize: 25 } }} />;
};

export default UbiCheckbox;
